/**
 * Background: The Updates happening in the createDataStore Providers break hydration since the value changes while the suspense boundaries are getting hydrated.
 * We fixed it by using `useSuspenseSafeHydrationDone` in createDataStore to add the useMemo deps only when hydration is done.
 * ^ This fixed the hydration issue, BUT, it made every customer related data showing up a lot late on the application, like:
 *  - Wishlist/Basket items appear after a ~5 seconds in product tiles/ headers
 * - User data in the header appears after a 2-3 seconds
 * - Wishlist icon click does nothing on the product tiles etc.
 *
 * Fix: Delaying the session/user data by a few milliseconds to make sure the hydration is done and then show the data.
 * This 800 ms delay seemingly fixes the hydration issue as well as the slowness of the user data appearing on the application.
 *
 * NOTE: on local development, we are adding 300 ms extra delay to make sure the hydration is done properly.
 */

export const delayCustomerDataToPreventHydrationErrors = async () => {
  await new Promise(resolve => setTimeout(resolve, 800));
};
